import { ApplicationTargetEnum } from '~types/app-selection';
import { RED_600, WHITE } from '~styles/colors';
import type { PreviewTheme } from './tokens';

/**
 * Circle K (rest of Canada) preview theme.
 *
 * There is no dedicated CK Figma for this revamp, so the CK theme
 * intentionally reuses the Couche-Tard brand color and logo. The only
 * BU-specific change is the bottom-tab layout: carwash is replaced by
 * the age-gated section per CTCAN-117 ("age gated section if you're in
 * circle k view").
 */
export const caTheme: PreviewTheme = {
    region: ApplicationTargetEnum.CA,
    colors: {
        primary: RED_600,
        primaryContrast: WHITE,
    },
    logo: {
        id: 'CK',
    },
    tabs: ['home', 'map', 'products', 'age-gated', 'more'],
};
